export interface MeetingRoomListFilterItem {
  field: string
  condition: string
  comparison: string
}

export interface MeetingRoomListRequestPayload {
  filterBy: MeetingRoomListFilterItem[]
  sort: string
  limit: number
  page: number
  totalRows: number
  match: string
}

const MEETING_ROOM_LIST_MAX_LIMIT = 2147483647

export const buildMeetingRoomListPayload = (params: {
  searchTerm?: string
  sort?: string
  page?: number
  limit?: number
  includeHidden?: boolean
}): MeetingRoomListRequestPayload => {
  const filterBy: MeetingRoomListFilterItem[] = []
  const trimmedSearch = params.searchTerm?.trim() ?? ''

  if (trimmedSearch) {
    filterBy.push({
      field: 'name',
      condition: trimmedSearch,
      comparison: 'lk',
    })
  }

  return {
    filterBy,
    sort: params.sort ?? '',
    limit: params.limit ?? MEETING_ROOM_LIST_MAX_LIMIT,
    page: params.page ?? 1,
    totalRows: 0,
    match: '',
  }
}
